import { buildStyleFns } from '../buildStyleFns';
export var borderRadiusStyleFnConfigs = [
    {
        name: 'borderRadius',
        properties: ['borderRadius'],
        system: 'shape',
    },
    {
        name: 'borderTopLeftRadius',
        properties: ['borderTopLeftRadius'],
        system: 'shape',
    },
    {
        name: 'borderTopRightRadius',
        properties: ['borderTopRightRadius'],
        system: 'shape',
    },
    {
        name: 'borderBottomLeftRadius',
        properties: ['borderBottomLeftRadius'],
        system: 'shape',
    },
    {
        name: 'borderBottomRightRadius',
        properties: ['borderBottomRightRadius'],
        system: 'shape',
    },
];
export var borderRadiusFns = buildStyleFns(borderRadiusStyleFnConfigs);
